"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 7.58a3.7 3.7 0 0 1 3.7-3.7h6.6a3.7 3.7 0 0 1 3.7 3.7v4.84a3.7 3.7 0 0 1-3.7 3.7H6.7a3.7 3.7 0 0 1-3.7-3.7z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.505 9.218a1.95 1.95 0 0 1 1.95-1.95h1.032c.723 0 1.31.586 1.31 1.31a.7.7 0 0 1-1.395.09h-.947a.55.55 0 0 0-.55.55v1.565c0 .303.246.55.55.55h.942a.7.7 0 0 1 1.4.022c0 .76-.617 1.377-1.378 1.377h-.964a1.95 1.95 0 0 1-1.95-1.95zm4.698 0a1.95 1.95 0 0 1 1.95-1.95h1.032c.724 0 1.31.586 1.31 1.31a.7.7 0 0 1-1.394.09h-.948a.55.55 0 0 0-.55.55v1.565c0 .303.247.55.55.55h.948a.7.7 0 0 1 1.394.09 1.31 1.31 0 0 1-1.31 1.31h-1.032a1.95 1.95 0 0 1-1.95-1.95z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ClosedCaptionFilledIcon20.js.map